import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectedOrganization = () =>
  createSelector(
    [
      (state: RootState) => state.organizations.data?.results ?? [],
      (state: RootState) => state.querystring,
    ],
    (organizations, querystring) => {
      const organizationId = querystring.organization_id;
      return organizations.find((org) => org.uuid === organizationId) || null;
    }
  );
